export default "__VITE_ASSET__DabrvQvL__"